import React from "react";
import Table from "react-bootstrap/Table";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import "./DetaljiTable.css";
import { ZoomInOutlined } from "@ant-design/icons";
import RazlogBrisanjaComponent from "./RazlogBrisanjaComponent";

const RevizorskiVjezbeniciDetaljiTable = (props) => {
  let osoba;
  let adresaOsobe;
  let osobaDrustvo = [];
  let dokumentOsobe;

  let revDrustva = [];
  let samostalniRevizori = [];

  let registar = props.children;

  osoba = registar[1];
  adresaOsobe = registar[2];
  osobaDrustvo = registar[3];
  dokumentOsobe = registar[4];

  revDrustva = osobaDrustvo.filter((x) => x.vrDrustva != 2);

  samostalniRevizori = osobaDrustvo.filter((x) => x.vrDrustva == 2);

  const noDataMessage = "";

  const { userRole } = props;
  const checkIfUserIsAdmin =
    userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

  return (
    <div id="printArea">
      {osoba.napomena ? (
        <RazlogBrisanjaComponent razlog={osoba.napomena} />
      ) : null}
      <h5>Pregled podataka</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Revizorski vježbenik</th>
            {checkIfUserIsAdmin ? <th scope="col">OIB</th> : null}
            <th scope="col">Registarski broj</th>
            {checkIfUserIsAdmin ? <th scope="col">Adresa</th> : null}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {osoba.ime} {osoba.prezime}
            </td>
            {checkIfUserIsAdmin ? <td>{osoba.oib}</td> : null}
            <td>{osoba.regBroj}</td>
            {checkIfUserIsAdmin ? (
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td className="inner-td">
                        <b>Ulica i kbr: </b>
                        {adresaOsobe.ulicaKbr
                          ? adresaOsobe.ulicaKbr
                          : noDataMessage}
                      </td>
                    </tr>
                    {adresaOsobe.brPoste || adresaOsobe.nazNaselja ? (
                      <tr>
                        <td className="inner-td">
                          <b>Grad: </b>
                          {adresaOsobe.brPoste}
                          {adresaOsobe.nazNaselja &&
                            " " + adresaOsobe.nazNaselja}
                        </td>
                      </tr>
                    ) : null}
                    {adresaOsobe.drzava ? (
                      <tr>
                        <td className="inner-td">
                          <b>Država: </b>
                          {adresaOsobe.drzava}
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </td>
            ) : null}
          </tr>
        </tbody>
      </Table>

      <h5>
        Revizorski vježbenik je povezan sa sljedećim subjektima ili revizorima
      </h5>

      <br></br>

      <h5>Revizorsko društvo</h5>

      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv</th>
            <th scope="col">Registarski broj</th>
            <th scope="col">Adresa</th>
            <th scope="col">Internet stranica</th>
            <th scope="col">Datum početka radnog odnosa</th>
            <th scope="col">
              Datum početka stručnog osposobljavanja bez zasnivanja radnog
              odnosa
            </th>
            <th scope="col">Detalji</th>
          </tr>
        </thead>
        <tbody>
          {revDrustva.length > 0 ? (
            revDrustva.map((drustvo, index) => (
              <tr key={`revizorsko-drustvo${index}`}>
                <td>
                  {drustvo.nazivDrustva
                    ? drustvo.nazivDrustva
                    : drustvo.imeDrustva + " " + drustvo.prezimeDrustva}
                </td>
                <td>{drustvo.regBrojDrustva}</td>
                <td>
                  <table>
                    <tbody>
                      {drustvo.ulicaKbrDrustva ? (
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {drustvo.ulicaKbrDrustva}
                          </td>
                        </tr>
                      ) : (
                        noDataMessage
                      )}

                      {drustvo.postanskiBrojDrustva ||
                      drustvo.nazivNaseljaDrustva ||
                      drustvo.gradDrustva ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {drustvo.postanskiBrojDrustva}
                            {drustvo.nazivNaseljaDrustva &&
                              " " + drustvo.nazivNaseljaDrustva}
                            {drustvo.gradDrustva && ", " + drustvo.gradDrustva}
                          </td>
                        </tr>
                      ) : null}

                      {drustvo.nazDrzaveDrustva ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {drustvo.nazDrzaveDrustva}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td className="focusable">
                  {drustvo.web ? (
                    <a href={"http://" + drustvo.web} target="_blank">
                      {drustvo.web}
                    </a>
                  ) : (
                    noDataMessage
                  )}
                </td>
                <td>{drustvo.datPocRo ? drustvo.datPocRo : noDataMessage}</td>
                <td>{drustvo.datPocSo ? drustvo.datPocSo : noDataMessage}</td>
                <td className="ant_batn">
                  <ButtonComponent
                    variant="secondary"
                    onClick={(e) =>
                      props.detaljiSecondaryClicked(
                        "drustvo",
                        drustvo.idDrustva,
                        drustvo.vrDrustva,
                        false
                      )
                    }
                  >
                    <ZoomInOutlined />
                  </ButtonComponent>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Samostalni revizor</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            <th scope="col">Registarski broj</th>
            <th scope="col">Adresa</th>
            <th scope="col">Internet stranica</th>
            <th scope="col">Datum početka radnog odnosa</th>
            <th scope="col">
              Datum početka stručnog osposobljavanja bez zasnivanja radnog
              odnosa
            </th>
            <th scope="col">Detalji</th>
          </tr>
        </thead>
        <tbody>
          {samostalniRevizori.length > 0 ? (
            samostalniRevizori.map((samostalniRevizor, index) => (
              <tr key={`samostalni-revizor${index}`}>
                <td>
                  {samostalniRevizor.imeDrustva}{" "}
                  {samostalniRevizor.prezimeDrustva}
                </td>
                <td>{samostalniRevizor.regBrojDrustva}</td>
                <td>
                  <table>
                    <tbody>
                      {samostalniRevizor.ulicaKbrDrustva ? (
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {samostalniRevizor.ulicaKbrDrustva}
                          </td>
                        </tr>
                      ) : (
                        noDataMessage
                      )}
                      {samostalniRevizor.postanskiBrojDrustva ||
                      samostalniRevizor.nazivNaseljaDrustva ||
                      samostalniRevizor.gradDrustva ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {samostalniRevizor.postanskiBrojDrustva}
                            {samostalniRevizor.nazivNaseljaDrustva &&
                              " " + samostalniRevizor.nazivNaseljaDrustva}
                            {samostalniRevizor.gradDrustva &&
                              ", " + samostalniRevizor.gradDrustva}
                          </td>
                        </tr>
                      ) : null}

                      {samostalniRevizor.nazDrzaveDrustva ? (
                        <tr key={`samostalni-revizor${index}`}>
                          <td className="inner-td">
                            <b>Država: </b>
                            {samostalniRevizor.nazDrzaveDrustva}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td className="focusable">
                  {samostalniRevizor.web ? (
                    <a href={"http://" + samostalniRevizor.web} target="_blank">
                      {samostalniRevizor.web}
                    </a>
                  ) : (
                    noDataMessage
                  )}
                </td>
                <td>
                  {samostalniRevizor.datPocRo
                    ? samostalniRevizor.datPocRo
                    : noDataMessage}
                </td>
                <td>
                  {samostalniRevizor.datPocSo
                    ? samostalniRevizor.datPocSo
                    : noDataMessage}
                </td>
                <td className="ant_batn">
                  <ButtonComponent
                    variant="secondary"
                    onClick={(e) =>
                      props.detaljiSecondaryClicked(
                        "drustvo",
                        samostalniRevizor.idDrustva,
                        samostalniRevizor.vrDrustva,
                        false
                      )
                    }
                  >
                    <ZoomInOutlined />
                  </ButtonComponent>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7"></td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default RevizorskiVjezbeniciDetaljiTable;
